import { applyMiddleware, combineReducers, compose, createStore as _createStore } from 'redux';
import thunk from 'redux-thunk';
import {
  banksReducer,
  bannersReducer,
  filterReducer,
  gksReducer,
  locationsReducer,
  locationReducer,
  tabsReducer,
  pikDataReducer,
  officesReducer,
} from '../../reducers';
import { IApplicationState, IReduxThunkContext, TReduxActions, TReduxStore } from '../../types/redux';
import { IHttpApi } from '@cian/http-api';
import { ILogger } from '@cian/logger';

let storeReminder: TReduxStore;

/**
 * Хелпер для создания Redux стора
 * @param initialState IApplicationState - предзагруженное состояние
 */
interface ICreateReduxStore {
  initialState: IApplicationState;
  debugEnabled: boolean;
  httpApi: IHttpApi;
  logger: ILogger;
}

export function createReduxStore({ initialState, debugEnabled, httpApi, logger }: ICreateReduxStore) {
  const reducers = combineReducers<IApplicationState, TReduxActions>({
    banks: banksReducer,
    banners: bannersReducer,
    filter: filterReducer,
    gks: gksReducer,
    location: locationReducer,
    locations: locationsReducer,
    offices: officesReducer,
    pikData: pikDataReducer,
    tabs: tabsReducer,
  });

  const thunkContext: IReduxThunkContext = { httpApi, logger };

  const composeEnhancers = debugEnabled ? (window && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose : compose;
  const storeEnchancers = composeEnhancers(applyMiddleware(thunk.withExtraArgument(thunkContext)));

  const createStore = (): TReduxStore => _createStore(reducers, initialState, storeEnchancers);

  if (process.env.NODE_ENV === 'development' && debugEnabled) {
    if (!storeReminder) {
      storeReminder = createStore();
    }

    storeReminder.replaceReducer(reducers);

    return storeReminder;
  }

  return createStore();
}
